var map = {
	"./digitale-teilhabe/bananen.jpg": 295,
	"./digitale-teilhabe/barrierearme-schriften.jpg": 3978,
	"./homepage/barrierearme-schriften.jpg": 4816,
	"./soziale-netzwerke-kennenlernen/logos.png": 2001
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1663;